import { FC } from 'react';
import './HeaderOpsSuportTab.scss';
import { IListOptionsSupport } from '../../../../types/OpsSupport';

export interface IHeaderOpsSuportTab {
  listOfOptionsSuppport: IListOptionsSupport[];
  handleChangeSupportOption: (option: IListOptionsSupport) => void;
  selectSupportOption?: IListOptionsSupport;
}

const HeaderOpsSuportTab: FC<IHeaderOpsSuportTab> = ({
  listOfOptionsSuppport,
  handleChangeSupportOption,
  selectSupportOption
}: IHeaderOpsSuportTab) => {
  return (
    <div id="headerOpsSuportTab">
      <div className="headerSupportContainer">
        {listOfOptionsSuppport &&
          listOfOptionsSuppport?.length > 0 &&
          listOfOptionsSuppport?.map((item, index) => {
            return (
              <div
                key={`tab-name-${item.name}-index-${index}`}
                className={`headerItem ${item.id === selectSupportOption?.id ? 'selectHeaderItem' : ''}`}
                onClick={() => {
                  handleChangeSupportOption(item);
                }}
              >
                <div className={`textHeaderItem ${item.id === selectSupportOption?.id ? 'textWhiteHeaderItem' : ''}`}>
                  {item.name}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default HeaderOpsSuportTab;
